<div class="ui-card"
     [ui-loading]="loading"
>
    @if (expandable && !loading) {
        <span class="ui-card__expand-button"  (click)="toggleExpand()">
            <button>
                <i class="pi pi-chevron-down"></i>
            </button>
        </span>
    }

    @if (!loading) {
        <div class="ui-card__content-wrapper"
             [ngClass]="{
            'expandable': expandable,
            'expanded': expandable && expanded
        }"
        >
            <div class="ui-card__content">
                <ng-content></ng-content>
            </div>
        </div>
    }
</div>
<div [style.display]="hasHeader ? 'flex' : 'none'" class="ui-card__header">
    <span [style.visibility]="cardTitle ? 'visible' : 'hidden'" [style.pointer-events]="cardTitle ? 'auto' : 'none'"
          class="title-wrapper"
          title="{{cardTitle}}"
    >
        <div class="title"><h3>{{ cardTitle }}</h3></div>
        @if (cardSubtitle) {
            <div class="sub-title"><h4>{{ cardSubtitle }}</h4></div>
        }
    </span>
    <div [style.display]="hasActions ? 'flex' : 'none'"
         class="ui-card__actions"
         [ngClass]="{
            'multiple-actions': hasMultipleActions,
            'single-action': !hasMultipleActions
         }"
    >
        <ng-content select="[card-action]"></ng-content>
    </div>
</div>
